var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filtersPopup",class:{ 'filtersPopup--open': _vm.isOpen }},[_c('div',{staticClass:"filtersPopup__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('button',{staticClass:"filtersPopup__close",on:{"click":_vm.close}},[_c('span',{staticClass:"icon-line-close"})])]),_vm._v(" "),_c('div',{class:[
      'filtersPopup__content',
      _vm.disableContentPadding ? 'filtersPopup__content--noPadding' : '',
    ]},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"filtersPopup__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }